import { useState } from 'react';
import { Text, Button } from '@msc-b2c/shared-components';
import { VoyagersClubMembershipContainerProps } from '@msc-b2c/interfaces/types';
import styles from './voyagersclubmembershipcontainer.module.scss';

export function VoyagersClubMembershipContainer({
  headerTitle,
  description,
  readMore,
  readLess,
  children,
}: Readonly<VoyagersClubMembershipContainerProps>) {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <div className={styles['cmp-voyagers-club-membership-container__header']}>
        <Text
          text={headerTitle}
          tagHtml={'div'}
          styleOption="cmp-text__large bold cmp-voyagers-club-membership-container__header-title"
        />

        <div className={styles['cmp-voyagers-club-membership-container__description-wrapper']}>
          <div
            className={`${styles['cmp-voyagers-club-membership-container__description']} ${
              isExpanded ? styles['extended'] : ''
            }`}
          >
            <Text
              text={description}
              styleOption="cmp-text__normal"
            />
          </div>

          {description && (
            <div className={styles['cmp-voyagers-club-membership-container__toggle']}>
              <Button
                text={isExpanded ? readLess : readMore}
                onClick={() => setIsExpanded(!isExpanded)}
                styleOption="cmp-button__link"
              />
            </div>
          )}
        </div>
      </div>

      {children && (
        <div className={styles['cmp-voyagers-club-membership-container__content']}>{children}</div>
      )}
    </>
  );
}

export default VoyagersClubMembershipContainer;
